import { UPDATE_WORK_STATUS_WS, UPDATE_WORK_STATUS_WS_ERROR, UPDATE_WORK_STATUS_WS_SUCCESS } from './actionTypes';

export const updateWorkStatusWS = (ws, isClosed, token, history) => {
  return {
    type: UPDATE_WORK_STATUS_WS,
    payload: { ws, isClosed, token, history },
  };
};

export const updateWorkStatusWSSuccess = (message) => {
  return {
    type: UPDATE_WORK_STATUS_WS_SUCCESS,
    payload: { message },
  };
};

export const updateWorkStatusWSError = (ws) => {
  return {
    type: UPDATE_WORK_STATUS_WS_ERROR,
    payload: ws,
  };
};
